module.exports = __webpack_public_path__ + "static/media/qualitat_region_1.5a28a63a.png";